/**
 * NS Common
 **/

export const NS_GET_COMMON_MODULE_INIT = 'NS_GET_COMMON_MODULE_INIT';
export const NS_GET_COMMON_MODULE_FAIL = 'NS_GET_COMMON_MODULE_FAIL';
export const NS_GET_COMMON_MODULE_SUCCESS = 'NS_GET_COMMON_MODULE_SUCCESS';

export const getNSCommonModuleInit = () => {
  return {
    type: NS_GET_COMMON_MODULE_INIT
  };
};

export const getNSCommonModuleSuccess = (payload) => {
  return {
    type: NS_GET_COMMON_MODULE_SUCCESS,
    payload
  };
};

export const getNSCommonModuleFail = (payload) => {
  return {
    type: NS_GET_COMMON_MODULE_FAIL,
    payload
  };
};
